import Nav from 'react-bootstrap/Nav';
import { useState } from 'react';
import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import { useRef } from 'react';
import '../../App.css';
import '../../css/bootstrap.scss';
import user_icon from "../../images/reg_user.png";
import { Link } from 'react-router-dom';
import Header from '../Includes/Header';
import Footer from '../Includes/Footer';
import { useNavigate } from 'react-router-dom';
import BackButton from '../Includes/BackButton';
import { useTranslation } from 'react-i18next';

function AllowCameraAccess() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [validated, setValidated] = useState(false);

    return (
        <>
            <Header />
            <Container fluid className='min-vh-custom bg-sky'>
                <Row>
                    <Col md={12}>
                        <div className='mt-5'>
                            <Col md={3} className='text-center py-4'>
                                <Row className='justify-content-center'>
                                    <BackButton />
                                </Row>
                            </Col>

                            <Col md={12} className='text-center justify-content-center'>
                                <img src={user_icon} width={50} />
                                <h3 className='text-center mt-3 mb-2'>{t('login.secure_title')}</h3>
                                <p className='text-secondary mb-4 letter-spacing-fix'>{t('login.allow_camera_subtitle')}</p>

                                <Row className='justify-content-center'>
                                    <Col md={4} className='bg-white rounded-3' style={{ width: '545px' }}>
                                        <Form noValidate validated={validated}>
                                            <Row className="text-center">
                                                <label className="form-label fw-bold py-3 letter-spacing-fix">{t('login.allow_camera_title')}</label>
                                                <p className='text-secondary small m-0'>{t('login.allow_camera_desc')}</p>
                                                <p className='text-secondary small m-0'>{t('login.allow_camera_dialog')}</p>
                                                <p className='text-secondary small'>{t('login.allow_camera_required')}</p>
                                            </Row>
                                            <Row className='mb-3'>
                                                <Col md={12} className='py-2 text-center'>
                                                    <Button className="btn rounded-5 border-0 text-white w-50" style={{ background: '#0B1628' }} onClick={() => { navigate('/') }}>{t('common.continue')}</Button>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </Col>
                                </Row>
                            </Col>
                        </div>
                    </Col>
                </Row>
            </Container>
            <Footer full={true} />
        </>
    );
}

export default AllowCameraAccess;
